import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { DataObjectGroupUrl } from './DataObjectGroupUrl';
import {
  DataObjectGroupDto,
  DataObjectGroupValidFormData,
} from '../schema/types';

const postDataObjectGroup = (systemClassifier: DataObjectGroupValidFormData) =>
  apiClient
    .post<DataObjectGroupDto>(
      expand(DataObjectGroupUrl.GROUP, {}),
      systemClassifier
    )
    .then((response) => response.data);

const patchDataObjectGroup = (
  id: number,
  systemClassifier: Partial<DataObjectGroupValidFormData>
) =>
  apiClient
    .put<DataObjectGroupDto>(
      expand(DataObjectGroupUrl.GROUP, { id }),
      systemClassifier
    )
    .then((response) => response.data);

const deleteDataObjectGroup = (id: number) =>
  apiClient
    .delete<void>(expand(DataObjectGroupUrl.GROUP, { id }))
    .then((response) => response.data);

export const useMutateDataObjectGroup = createApiMutationHook(
  ['data-object-group'],
  getMutationFn(
    postDataObjectGroup,
    patchDataObjectGroup,
    deleteDataObjectGroup
  )
);
